import awesomeNumber from "awesome-phonenumber";
import { FormValidationRule } from "../../forms/types";

const isFixedLine: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (v && Array.isArray(v) && c.phoneTypeCheck.fixed_line && !c.phoneTypeCheck.mobile) {
        const parsedNumber = awesomeNumber.parsePhoneNumber(v[0],{
            regionCode: v[1]
        });

        if (!parsedNumber.typeIsFixedLine) {
            valid = false;
            message = "Not a valid fixed line phone number.";
        }
    }
    return [valid, message];
};

export default isFixedLine;
